import React, { useState } from 'react';

import Button from 'bs/Button';
import ButtonGroup from 'bs/ButtonGroup';

export const Dropdown = ({ className = '', children, flavor = 'light', label = 'Select', links = [] }) => {
    const [expand, setExpand] = useState(false);

    return (
        <ButtonGroup className={className}>
            <Button flavor={flavor} onClick={() => setExpand(!expand)} className='dropdown-toggle'>
                {label}
            </Button>
            <div className={`dropdown-menu  dropdown-menu-right ${expand && 'show'}`}>
                {links.map(({ label, onClick, ...linkProps }, idx) => (
                    <Button
                        key={idx}
                        className='dropdown-item'
                        onClick={e => {
                            e.preventDefault();
                            onClick && onClick(e);
                            setExpand(false);
                        }}
                        {...linkProps}
                    >{label}</Button>
                ))}
            </div>
        </ButtonGroup>
    );
};

export default Dropdown;
